module.exports = __webpack_public_path__ + "static/img/bg4.5a68467.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg4.jpg
// module id = Vzcp
// module chunks = 11